import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function CtaSection() {
  const ref = useScrollAnimation<HTMLDivElement>();

  return (
    <section ref={ref} className="scroll-animate py-16 md:py-24 px-4 md:px-6 bg-primary/5">
      <div className="max-w-3xl mx-auto text-center">
        <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-8 leading-relaxed">
          천안GF골프연습장을
          <br />
          더욱 자세히 알고싶다면?
        </h4>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://www.instagram.com/gf_golf_cheonan/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full hover:bg-primary-light transition whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-lg" />
            </div>
            <span className="text-sm font-medium">천안GF골프연습장 인스타그램</span>
          </a>
        </div>
      </div>
    </section>
  );
}